module.exports = __webpack_public_path__ + "static/media/electricals_orient.b9dedd20.jpg";